import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import ArticleList from '../components/article-list';

export default ({ data: { allPrismicDataProjects: { edges } }, location: { pathname } }) => {
    if (!edges) return null;
    const articleList = edges.map(({ node }) => ({
        uid: node.uid,
        image: node.data.thumbnail,
        title: node.data.title.text,
        body: node.data.description.text,
        date: (new Date(node.last_publication_date)).toLocaleDateString('en-US', {
            day: 'numeric',
            year: 'numeric',
            month: 'short'
        })
    }));

    return <Layout pathname={pathname}><ArticleList pathname={pathname} articleList={articleList} forData /></Layout>;
};

export const query = graphql`
    query DataProjectssQuery {
        allPrismicDataProjects(sort: {fields: [last_publication_date], order: DESC}) {
            edges {
                node {
                    last_publication_date
                    uid
                    data {
                        title {
                            text
                        }
                        description {
                            text
                        }
                        thumbnail {
                            url
                            dimensions {
                                width
                                height
                            }
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 663, maxHeight: 200, quality: 100, cropFocus: CENTER) {
                                        ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
